import * as Storage from 'utils/local-storage'

export const getCurrentPathId = async (): Promise<string | undefined> => {
    if (typeof window === 'undefined') return undefined

    return (await Storage.get(Storage.Keys.CurrentPathId)) as string | undefined
}

export const setCurrentPathId = async (value: string) => {
    if (typeof window !== 'undefined') {
        return await Storage.set(Storage.Keys.CurrentPathId, value)
    }
}
